export const imageAnimationParamsRight = [
    //  Woman by pool
    {
        initialY: '125%',
        finalY: '0%',
        initialBlur: '0px',
        finalBlur: '0px',
    },
    //  Glass of wine
    {
        initialY: '-120%',
        finalY: '0%',
        initialBlur: '8px',
        finalBlur: '0px',
    },
    // tea set
    {
        initialY: '200%',
        finalY: '0%',
        initialBlur: '13px',
        finalBlur: '0px',
    },
    //  Swimming pool
    {
        initialY: '-200%',
        finalY: '0%',
        initialBlur: '0px',
        finalBlur: '0px',
    },
    //  breakfast
    {
        initialY: '120%',
        finalY: '0%',
        initialBlur: '5px',
        finalBlur: '0px',
    },
    //  dark bar
    {
        initialY: '500%',
        finalY: '0%',
        initialBlur: '13px',
        finalBlur: '0px',
    },
];
export const imageAnimationParamsCenter = [
    //  Green couch
    {
        initialY: '140%',
        finalY: '0%',
        initialBlur: '0px',
        finalBlur: '0px',
    },
    //  Pink Cocktail
    {
        initialY: '-130%',
        finalY: '0%',
        initialBlur: '0px',
        finalBlur: '0px',
    },
    //  Orange Table
    {
        initialY: '-180%',
        finalY: '0%',
        initialBlur: '0px',
        finalBlur: '0px',
    },
    //  Swimming pool
    {
        initialY: '190%',
        finalY: '0%',
        initialBlur: '3px',
        finalBlur: '0px',
    },
    //  Lady in red and white
    {
        initialY: '-200%',
        finalY: '0%',
        initialBlur: '10px',
        finalBlur: '0px',
    },
    //  Dark bar
    {
        initialY: '100%',
        finalY: '0%',
        initialBlur: '3px',
        finalBlur: '0px',
    },
];
export const layoutRight = [
    //  Woman by pool
    {
        id: 'image2',
        width: 400,
        height: 400,
        sizes: {
            base: { ratio: 1, vw: 1 / 2 },
            md: { vw: 1 / 3 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-1 -top-[5%] left-1/2',
            sizeCls: 'w-[224px] h-[249px] -ml-[112px]',
        },
        tablet: {
            positionCls: 'md:left-[6%] md:top-[6%]',
            sizeCls: 'md:w-[260px] md:h-[260px] md:ml-0',
        },
        desktop: {
            positionCls: 'lg:left-[10%] xl:left-[12%]',
            sizeCls: 'lg:w-[300px] lg:h-[300px] xl:w-[400px] xl:h-[400px]',
        },
    },
    //  Glass of wine
    {
        id: 'image3',
        width: 320,
        height: 320,
        sizes: {
            base: { ratio: 1, vw: 2 / 5 },
            md: { vw: 1 / 4 },
            lg: { vw: 1 / 5 },
            xl: { vw: 1 / 4 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 top-[16%] right-[5%] xs:right-[12%]',
            sizeCls: 'w-[164px] h-[182px]',
        },
        tablet: {
            positionCls: 'md:left-[20%] md:top-[40%]',
            sizeCls: 'md:w-[200px] md:h-[200px]',
        },
        desktop: {
            positionCls: 'lg:top-[48%] xl:top-auto xl:bottom-[20%] 2xl:bottom-[24%] 4xl:bottom-[26%] xl:left-[22%] lg:left-[27%]',
            sizeCls: 'xl:w-[320px] xl:h-[320px]',
        },
    },
    // tea set
    {
        id: 'image4',
        width: 200,
        height: 200,
        sizes: {
            base: { ratio: 1, vw: 1 / 3 },
            md: { vw: 1 / 6 },
            '3xl': { ratio: 4 / 6 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 bottom-[14%] right-1/2',
            sizeCls: 'w-[180px] h-[140px] -mr-[90px]',
        },
        tablet: {
            positionCls: 'md:bottom-[20%] md:right-[45%]',
            sizeCls: 'md:w-[200px] md:h-[200px] md:ml-0',
        },
        desktop: {
            positionCls: 'lg:bottom-[15%] lg:right-[41%] xl:bottom-[18%] xl:right-[38%]',
            sizeCls: 'lg:w-[200px] lg:h-[200px] xl:w-[280px] xl:h-[280px] 3xl:w-[400px]',
        },
    },
    //  Swimming pool
    {
        id: 'image5',
        width: 300,
        height: 300,
        sizes: {
            base: { ratio: 1, vw: 1 / 2 },
            md: { vw: 1 / 4 },
            xl: { vw: 1 / 3 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-1 bottom-[1%] left-[6%] xs:left-[12%]',
            sizeCls: 'w-[170px] h-[170px]',
        },
        tablet: {
            positionCls: 'md:left-auto md:right-[22%] md:bottom-[2%]',
            sizeCls: 'md:w-[170px] md:h-[170px]',
        },
        desktop: {
            positionCls: 'lg:bottom-0 lg:right-[18%] xl:right-[18%] 3xl:right-[20%] 4xl:right-[23%] 3xl:bottom-[4%]',
            sizeCls: 'lg:w-[180px] lg:h-[180px] xl:w-[220px] xl:h-[220px]',
        },
    },
    //  breakfast
    {
        id: 'image6',
        width: 200,
        height: 200,
        sizes: {
            base: { ratio: 1, vw: 1 / 3 },
            md: { vw: 1 / 6 },
            lg: { vw: 1 / 8 },
            xl: { vw: 1 / 6 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 top-[10%] left-[6%] xs:left-[12%]',
            sizeCls: 'w-[174px] h-[196px]',
        },
        tablet: {
            positionCls: 'md:top-[64%] md:left-[6%]',
            sizeCls: 'md:w-[250px] md:h-[250px]',
        },
        desktop: {
            positionCls: 'xl:top-auto xl:bottom-[4%] lg:left-[6%] xl:left-[4%] 4xl:left-[8%] 4xl:bottom-[6%]',
            sizeCls: 'lg:w-[275px] lg:h-[275px]',
        },
    },
    //  dark bar
    {
        id: 'image1',
        width: 200,
        height: 200,
        sizes: {
            base: { ratio: 1, vw: 1 / 3 },
            md: { vw: 1 / 6 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 bottom-[3%] xs:bottom-[4%] right-[6%] xs:right-[12%]',
            sizeCls: 'w-[150px] h-[150px] xxs:w-[180px] xxs:h-[180px]',
        },
        tablet: {
            positionCls: 'md:bottom-[14%] md:right-[5%]',
            sizeCls: 'md:w-[200px] md:h-[200px]',
        },
        desktop: {
            positionCls: 'lg:bottom-[15%] xl:bottom-[19%] lg:right-[6%] xl:right-[4%] 4xl:right-[8%]',
            sizeCls: 'lg:w-[250px] lg:h-[250px] xl:w-[280px] xl:h-[280px] 2xl:w-[300px] 2xl:h-[300px]',
        },
    },
];
export const layoutCenter = [
    //  Green couch
    {
        id: 'image1',
        width: 323,
        height: 323,
        sizes: {
            base: { ratio: 1, vw: 2 / 5 },
            md: { vw: 1 / 4 },
            lg: { vw: 1 / 3 },
            xl: { vw: 1 / 4 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-1 top-[5%] left-[3%]',
            sizeCls: 'w-[160px] h-[177px]',
        },
        tablet: {
            positionCls: 'md:top-[4%] md:left-[5%]',
            sizeCls: 'md:w-[237px] md:h-[237px]',
        },
        desktop: {
            positionCls: 'lg:top-[8%] lg:left-[4%] xl:left-[8%] 4xl:top-[6%] 4xl:left-[18%]',
            sizeCls: 'lg:w-[323px] lg:h-[323px]',
        },
    },
    //  Pink Cocktail
    {
        id: 'image3',
        width: 295,
        height: 360,
        sizes: {
            base: { ratio: 1, vw: 2 / 5 },
            md: { vw: 1 / 4 },
            lg: { vw: 1 / 3 },
            xl: { vw: 1 / 4 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-1 top-[14%] right-[3%]',
            sizeCls: 'w-[136px] h-[154px]',
        },
        tablet: {
            positionCls: ' md:right-[5%]',
            sizeCls: 'md:w-[191px] md:h-[232px]',
        },
        desktop: {
            positionCls: 'lg:top-[154px] lg:right-[5%] 2xl:right-[8%] 4xl:right-[15%]',
            sizeCls: 'lg:w-[295px] lg:h-[360px]',
        },
    },
    //  Orange Table
    {
        id: 'image4',
        width: 284,
        height: 378,
        sizes: {
            base: { ratio: 1, vw: 1 / 3 },
            md: { vw: 1 / 4 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 bottom-[14%] right-[3%]',
            sizeCls: 'w-[140px] h-[178px]',
        },
        tablet: {
            positionCls: 'md:bottom-[18%]',
            sizeCls: 'md:w-[159px] md:h-[211px]',
        },
        desktop: {
            positionCls: 'lg:top-[48%] lg:right-0 xl:right-[2%] 4xl:right-[10%]',
            sizeCls: 'lg:w-[242px] lg:h-[360px] xl:w-[284px] xl:h-[378px]',
        },
    },
    //  Swimming pool
    {
        id: 'image5',
        width: 720,
        height: 368,
        sizes: {
            base: { vw: 1 / 2, ratio: 319 / 255 },
            md: { ratio: 2 / 1 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 bottom-0 left-1/2 -ml-[150px]',
            sizeCls: 'w-[300px] h-[178px]',
        },
        tablet: {
            positionCls: 'md:bottom-[68px] md:-ml-[225px] ',
            sizeCls: 'md:w-[450px] md:h-[230px]',
        },
        desktop: {
            positionCls: 'lg:bottom-[1%] lg:-ml-[306px] xl:-ml-[360px]',
            sizeCls: 'lg:w-[612px] lg:h-[345px] xl:w-[720px] xl:h-[368px]',
        },
    },
    //  Lady in red and white
    {
        id: 'image6',
        width: 255,
        height: 319,
        sizes: {
            base: { ratio: 255 / 319, vw: 1 / 3 },
            md: { vw: 1 / 4 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 bottom-[15%] left-[3%]',
            sizeCls: 'w-[120px] h-[144px]',
        },
        tablet: {
            positionCls: 'md:bottom-[10%] md:left-[3%]',
            sizeCls: 'md:w-[204px] md:h-[255px]',
        },
        desktop: {
            positionCls: 'lg:bottom-[33%] lg:left-0 xl:left-[3%] 4xl:left-[10%]',
            sizeCls: 'lg:w-[255px] lg:h-[319px]',
        },
    },
    //  Dark bar
    {
        id: 'image2',
        width: 212,
        height: 212,
        sizes: {
            base: { ratio: 1, vw: 1 / 3 },
            md: { vw: 1 / 4 },
            lg: { vw: 1 / 5 },
        },
        mobile: {
            positionCls: 'z-locomotive-images-layer-2 -top-[20px] left-1/2 -ml-[90px] xs:-ml-[100px]',
            sizeCls: 'w-[180px] h-[120px] xxs:w-[200px] xxs:h-[150px]',
        },
        tablet: {
            positionCls: 'md:left-1/2 md:-ml-[120px] md:top-[4%]',
            sizeCls: 'md:w-[240px] md:h-[165px]',
        },
        desktop: {
            positionCls: 'lg:top-[1%] lg:-ml-[170px]',
            sizeCls: 'lg:w-[340px] lg:h-[280px]',
        },
    },
];
